import React, { useState } from 'react';
import { Fab, Button, Grid, makeStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import theme from '../../../theme';
import useSessionContext from '../../../sessions/useSessionContext';
import MetiersAutoComplete from '../../../Form/MetiersAutoComplete';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiPaper-root': {
      overflow: 'hidden',
      [theme.breakpoints.up('sm')]: {
        minWidth: 500,
      },
    },
  },
  error: {
    color: '#e5087e',
    fontFamily: ['Dosis', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    marginTop: '3px',
    fontWeight: '500',
  },

  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(4),
  },
  '& > *': {
    zIndex: 100,
    position: 'relative',
  },

  submit: {
    margin: theme.spacing(3, 0, 3),
  },
}));

const AddMetier = (props) => {
  const [open, setOpen] = React.useState(false);
  const {
    refreshUserData,
    updateUser,
    user
  } = useSessionContext();
  const [formData, setFormData] = useState({
    metiers: null,
  });
  const {
    show,
    closeModal,
    partnerMetiers,
  } = props;

  const handleClose = () => {
    closeModal(false);
  };
  const errors = {};

  const updateMetiers = (metiers) => {
    const raw = {
      user: {
        partner_metiers: metiers      
      },
    };
    updateUser(raw).then((response) => {
      if (response.status === 200) {
        handleClose();
        refreshUserData();
        setFormData({ metiers: null });
      }
    });
  };

  const validateForm = (verifyAll = false) => {
    const errors = {};
    if (formData.jobs || verifyAll) {
      if (formData.jobs === null) {
        errors.jobs = 'Vous devez choisir au moins un métier!';
      }
    }

    return Object.keys(errors).length < 1;
  };

  const onFormChange = (event) => {
    setFormData(
      {
        ...formData,
        [event.target.name]: event.target.value
      },
      validateForm(),
    );
  };

  const handleSubmit = () => {
    const raw = {
      user: {
        partner_metiers: formData.jobs      
      },
    };
    updateUser(raw).then((response) => {
      if (response.status === 200) {
        handleClose();
        refreshUserData();
        setFormData({ jobs: [] });
      }
    });  
  };


  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles(theme);
  return (
    <div>
      <Dialog
        className={classes.root}
        open={show ? open === false : open === true}
        onClose={handleClose}
        aria-labelledby="Servue"
        fullScreen={fullScreen}
        large="500px"
      >
        <Grid container spacing={2}>
          <DialogContent>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '10px 0',
              }}
            >
              <Fab color="secondary" aria-label="close" onClick={handleClose}>
                <CloseIcon/>
              </Fab>
            </Grid>
            <Grid item xs={12}>
              <DialogTitle>Choisir un métier dans la liste</DialogTitle>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12}>
              <MetiersAutoComplete
                userType={"Partner"}
                limit={1}
                name="metiers"
                multiple
                onFormChange={onFormChange}
                errors={errors}
                formData={formData}
              />
              </Grid>
            </Grid>

            <DialogActions>
              <Button onClick={handleSubmit}>Valider</Button>
            </DialogActions>
          </DialogContent>
        </Grid>
      </Dialog>
    </div>
  );
};

export default AddMetier;
